<template>
    <div class="credit-bar">
        <div class="logo-wrap">
            <a href="https://www.dietitian.or.jp/" target="_blank">
                <img src="@/assets/logo-assosiation.png" alt="">
            </a>
            <a href="https://www.nutas.jp/" target="_blank">
                <img src="@/assets/logo-nutas.png" alt="">
            </a>
        </div>
        <div class="archive">
            <span>ARCHIVES</span>
            <ul>
                <li><a href="https://www.nutas.jp/84/2017/" target="_blank">2017</a></li>
                <li><a href="https://www.nutas.jp/84/2018/" target="_blank">2018</a></li>
                <li><a href="https://www.nutas.jp/84/2019/" target="_blank">2019</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'credit-bar'
}
</script>

<style lang="scss" scoped>
.credit-bar{
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-flow: row wrap;
    width: calc(100% - 40px);
    padding: 0 20px;
    @media #{$IE}{
        justify-content: space-between;
    }
    @media #{$maxM}{
      flex-flow: column;
      justify-content: center;
    }
    
    .logo-wrap{
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 16px;
      @media #{$maxM}{
        padding: 0 20px;
        width: calc(100% - 40px);
      }
        a{
          display: flex;
          justify-content: center;
          align-items: center;
          height: 46px;
          width: auto;
          margin-left: 33px;
          &:first-child{
            height: 40px;
            padding-right: 33px;
            margin-left: 0;
            border-right: 1px solid $black;
            @media #{$maxM}{
              padding-right: 18px;
            }
          }
          @media #{$maxM}{
            width: calc(50% - 18px);
            height: auto;
            margin-left: 18px;
          }
          img{
            width: auto;
            height: 100%;
            @media #{$maxM}{
              width: 100%;
              height: auto;
            }
          }
        }
    }
    .archive{
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: stretch;
      font-size: 0.875em;
      font-family: $roboto;
      letter-spacing: 0.01em;
      font-weight: 600;
      margin-bottom: 16px;
      span{
        margin-right: 11px;
      }
        ul{
          display: flex;
          flex-flow: row nowrap;
          align-items: stretch;
          justify-content: space-between;
            li{
              margin-right: 12px;
              font-family: $roboto;
              line-height: 1em;
              font-weight: 400;
              cursor: pointer;
              &:last-child{
                margin-right: 0;
              }
            }
        }
    }
}
</style>